import { render, staticRenderFns } from "./showEmailTable.vue?vue&type=template&id=0a2aa008&scoped=true&"
import script from "./showEmailTable.vue?vue&type=script&lang=js&"
export * from "./showEmailTable.vue?vue&type=script&lang=js&"
import style0 from "./showEmailTable.vue?vue&type=style&index=0&id=0a2aa008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2aa008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2aa008')) {
      api.createRecord('0a2aa008', component.options)
    } else {
      api.reload('0a2aa008', component.options)
    }
    module.hot.accept("./showEmailTable.vue?vue&type=template&id=0a2aa008&scoped=true&", function () {
      api.rerender('0a2aa008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showEmailTable.vue"
export default component.exports